import React from 'react';
import FilterComponents from '../../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import KYCForm from './../KYCForm/KYCForm.tsx'

function ServiceChargeSetupPage(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'percentage', headerName: 'Amount', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', name: 'HOT', percentage: '10%' },
        { id: 2, checkbox: '', name: 'COLD', percentage: '0%' },
    ];
    return (
        <div  >
            <div >
                {/* <FilterComponents title={"OK"} isItem={2} />
                <CustomDataGrid columns={columns} dataRows={dataRows} /> */}
                <KYCForm from="fillup" />
            </div>
        </div >
    );
}

export default ServiceChargeSetupPage;